'use client'
import styles from './TopPartnersContainerSkeleton.module.scss'
import { Skeleton } from '@/tools/ui'

export const TopPartnersContainerSkeleton = ({ amount = 8 }: { amount?: number }) => (
  <article className={styles.wrapper}>
    {Array.from({ length: amount }).map((_, index) => (
      <Skeleton key={index} className={styles.shape}>
        <svg height="133" width="127" xmlns="http://www.w3.org/2000/svg">
          <circle className="pintxo-skeleton-shape" cx="65" cy="65" r="62" />
          <rect
            className="pintxo-skeleton-shape"
            height="20"
            rx="5"
            ry="5"
            width="95"
            x="17.5"
            y="114"
          />
        </svg>
      </Skeleton>
    ))}
  </article>
)
